export const isSalesUserRole = (role: string | null | undefined) => {
  return role?.trim().toLowerCase() === "sales";
};
